import { Icon, IconsEnum } from 'components/Icons';
import { Dialog } from 'components/dialog/Dialog';
import styles from './DialogFeedback.module.scss';
import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import { useGetLabelByKey, useTranslation } from 'hooks/useLingUI';
import { useMemo } from 'react';
import { SeamlessHomeLink, SeamlessHomeWrapper } from 'features/dashboard/components/SeamlessHomeLink';

export type DialogFeedbackProps = {
  isOpen: boolean;
  message: string;
  queryStatus?: string;
  formStatus?: string;
  handleCloseDialog: () => void;
};

export const DialogFeedback = ({
  isOpen,
  message,
  queryStatus,
  formStatus,
  handleCloseDialog,
}: DialogFeedbackProps) => {
  const { t } = useTranslation();

  const { labelTitle, iconType, iconColor } = useMemo<{
    iconType: IconsEnum;
    iconColor: string;
    labelTitle: string;
  }>(() => {
    let wFormStatus = formStatus;
    if (queryStatus === QueryStatus.rejected) {
      wFormStatus = 'error';
    } else if (queryStatus === QueryStatus.fulfilled) {
      wFormStatus = 'success';
    }

    switch (wFormStatus) {
      case 'error':
        return {
          iconType: IconsEnum.EXCLAMATION_CIRCLE,
          iconColor: 'var(--color-warning)',
          labelTitle: t('title-generic-error'),
        };
      case 'success':
        return {
          iconType: IconsEnum.SUCCESS,
          iconColor: 'var(--color-success)',
          labelTitle: t('200'),
        };
      case 'warning':
      case 'informative':
      default:
        return {
          iconType: IconsEnum.EXCLAMATION_CIRCLE,
          iconColor: 'var(--color-accent)',
          labelTitle: t('warning'),
        };
    }
  }, [queryStatus, formStatus, t]);

  return (
    <Dialog open={isOpen} isMobileFullScreen={true} onOpenChange={handleCloseDialog}>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <Icon iconId={iconType} color={iconColor} className={styles.icon} />
          <p className={styles.title}>{labelTitle}</p>
          <p dangerouslySetInnerHTML={{ __html: message }} suppressHydrationWarning className={styles.message} />
        </div>
        <SeamlessHomeWrapper>
          <button className={styles.closeButton} onClick={handleCloseDialog}>
            ok
          </button>
          <SeamlessHomeLink />
        </SeamlessHomeWrapper>
      </div>
    </Dialog>
  );
};
